import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MadisonInsuranceComponent } from '../madison-insurance/madison-insurance.component';
import { MadisonPHIComponent } from '../madison-phi/madison-phi.component';
import { MadisonThankyouComponent } from '../madison-thankyou/madison-thankyou.component';
import { MadisonverificationComponent } from '../madisonverification/madisonverification.component';
import { MedisonRegistrationComponent } from '../medison-registration/medison-registration.component';
import { MadisonReferalComponent } from '../madison-referal/madison-referal.component';
import { MadisonInjuredComponent } from '../madison-injured/madison-injured.component';

const routes: Routes = [
  {
    path: '',
    component:  MadisonverificationComponent
  },
  {
    path: 'madison-registration',
    component: MedisonRegistrationComponent
  },
  {
    path: 'madison-insurance', 
    component: MadisonInsuranceComponent
  },
  {
    path: 'madison-thankyou', 
    component: MadisonThankyouComponent
  },
  {
    path: 'madison-phi', 
    component: MadisonPHIComponent
  }, 
  {
    path: 'madison-ref', 
    component: MadisonReferalComponent
  },
  {
    path: 'madison-inj', 
    component: MadisonInjuredComponent
  },
  ]; 

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MedisonMedicalRoutingModule { }
